const EXCLUDED_ITEM_SLUGS: ReadonlySet<string> = new Set([
	"cqc-72-entrenchment-tool",
	"sg-88-break-action-shotgun",
]);

function slugify(name: string): string {
	return name
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/(^-|-$)/g, "");
}

export function isExcludedItemName(name: string): boolean {
	return EXCLUDED_ITEM_SLUGS.has(slugify(name));
}
